import { saveAs } from 'file-saver';
import type { GeneratedLetter } from './types';

export function copyLetterToClipboard(letter: GeneratedLetter): Promise<void> {
  return navigator.clipboard.writeText(letter.fullText);
}

export function downloadLetterAsText(letter: GeneratedLetter, filename: string): void {
  const blob = new Blob([letter.fullText], { type: 'text/plain;charset=utf-8' });
  saveAs(blob, filename);
}

export function downloadLetterAsDoc(letter: GeneratedLetter, filename: string): void {
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Cover Letter</title>
<style>body{font-family:Georgia,serif;max-width:680px;margin:40px auto;line-height:1.6;color:#18181b;font-size:11pt;white-space:pre-wrap;}</style>
</head><body>${escapeHtml(letter.fullText)}</body></html>`;
  const blob = new Blob([html], { type: 'application/msword;charset=utf-8' });
  saveAs(blob, filename);
}

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function slugify(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'cover-letter';
}
